import React from "react";

import { object, shape } from "prop-types";
import { LazyCollection, LazyLoadImages, replaceAllStoriesInCollection, WithPreview } from "@quintype/components";

import { getCollectionTemplate } from "../get-collection-template";
import { NewsSummariesButton } from "../atoms/NewsSummariesButton";
import get from "lodash/get";
// import { GoAdFreeWidgetBlack } from "../molecules";
// import GoAdFreeWidgetRed from "../molecules/GoAdFreeWidgetRed";

export const HomePage = (props, newsSummaryStatus) => {

  newsSummaryStatus = get(props, ["config", "publisher-attributes", "news-summary-status"], false);

  return (
    <div className="container">
      <h1 style={{ display: "none" }}>Open Magazine - Top Stories</h1>
{newsSummaryStatus && <NewsSummariesButton />}
      <LazyLoadImages>
        <LazyCollection
          collection={props.data.collection}
          collectionTemplates={getCollectionTemplate}
          lazyAfter={6}
          className="home-component"
          {...props}
        />
      </LazyLoadImages>
      {/* <GoAdFreeWidgetRed />
      <GoAdFreeWidgetBlack /> */}
    </div>
  );
};

HomePage.propTypes = {
  data: shape({
    collection: object,
  }),
};

export const HomePagePreview = WithPreview(HomePage, (data, story) =>
  Object.assign({}, data, {
    collection: replaceAllStoriesInCollection(data.collection, story),
  })
);
